import { Dropdown, Button } from 'antd'
import type { MenuProps } from 'antd'
import {
  EllipsisOutlined,
  WifiOutlined,
  DisconnectOutlined,
  CheckOutlined
} from '@ant-design/icons'

interface LiveUpdatesControlProps {
  enabled: boolean
  isConnected: boolean
  onChange: (enabled: boolean) => void
}

export function LiveUpdatesControl({
  enabled,
  isConnected,
  onChange
}: LiveUpdatesControlProps): JSX.Element {
  const isActive = enabled && isConnected

  const statusIcon = isActive ? (
    <WifiOutlined className='text-green-500' aria-hidden='true' />
  ) : (
    <DisconnectOutlined className='text-gray-400' aria-hidden='true' />
  )

  const menuItems: MenuProps['items'] = [
    {
      key: 'live-updates',
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {statusIcon}
          <span>Live updates</span>
          {enabled && <CheckOutlined style={{ marginLeft: 'auto' }} aria-hidden='true' />}
        </span>
      ),
      disabled: !isConnected,
      onClick: () => onChange(!enabled)
    }
  ]

  return (
    <Dropdown menu={{ items: menuItems }} trigger={['click']}>
      <Button
        type='text'
        size='small'
        shape='circle'
        icon={<EllipsisOutlined />}
        aria-label='Live updates options'
        aria-haspopup='menu'
        className='flex justify-center items-center'
      />
    </Dropdown>
  )
}

export default LiveUpdatesControl
